<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      short-title="IG"
      title="IntegraCargo"
      logo = "/favicon.png"
      link= "supplier.order"
    >
      <template  slot="links">
        <sidebar/>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground" id="main-page" v-if="render">
      <navbar :refresh="refresh" @update-page="updatePage" @language="rerender"></navbar>
      <router-view name="header"></router-view>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import Navbar from "./Navbar";
  import Footer from "./Footer";
  import SidebarFixedToggleButton from '@/resources/layouts/SidebarFixedToggleButton.vue';
  import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';
  import Sidebar from "./Sidebar.vue";
  import * as Cookies from "js-cookie";
  import axios from 'axios';
  import VerifyAppVersion from "@/resources/mixins/VerifyAppVersion";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }


  export default {
    name: "Layout",
    mixins:[VerifyAppVersion],
    components: {
      Navbar,
      Footer,
      Sidebar,
      SidebarFixedToggleButton,
      SlideYDownTransition,
      ZoomCenterTransition
    },
    data() {
      return {
        user: {},
        base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
        sidebarBackground: 'primary', //vue|blue|orange|green|red|primary
        render: true
      };
    },
    created(){
    },
    updated(){
    if(navigator.platform.startsWith('Win')){
      setTimeout(() => {
        let div = this.$el.querySelector("#main-page");
        div.scrollTop = 0;
      }, 100);
    }
    },
    computed:{
      token() {
        return Cookies.getJSON("token");
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      initScrollbar() {
        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          // if we are on windows OS we activate the perfectScrollbar function
          initScrollbar('sidebar');
          initScrollbar('main-panel');
          initScrollbar('sidebar-wrapper');

          docClasses.add('perfect-scrollbar-on');
        } else {
          docClasses.add('perfect-scrollbar-off');
        }
      },

      rerender(){
        this.render = false;

        this.$nextTick(() => {
          this.render = true;
        });
      }
    },
    mounted() {
      this.initScrollbar();
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }

  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }

  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
